<!--  -->
<template>
    <div>
    <head-nav :key="Math.random()"/>
    <div class="page flex-col">
    <div class="main1 flex-col">
      <div class="bd1 flex-col">
        <div class="main2 flex-col"></div>
        <div class="main3 flex-col justify-center">
          <div class="main4">
            <!-- <span class="infoBox1">{{testpapertitle}}能力综合测试<br /></span>
            <span class="info1">认证成绩单</span> -->
          </div>
          <div class="main5 flex-col"></div>
        </div>
        <div class="main6 flex-col">
          <div class="group1 flex-col justify-between">

            <div class="layer1 flex-col align-center">
            <h4 class="kscj">测评认证成绩单</h4>
              <div class="box1 flex-col">
                <span class="info2">个人信息</span>
                <el-descriptions  class="margin-top" :column="2" border>
                <el-descriptions-item>
                  <template slot="label">
                    姓名
                  </template>
                   {{name}}
                  </el-descriptions-item>
                  <el-descriptions-item>
                <template slot="label">
                    性别
                </template>
                  {{sex}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                   <template slot="label">
                    证件号码
                  </template>
                      {{numid}}
                  </el-descriptions-item>
                  <el-descriptions-item>
                  <template slot="label">
                    学号
                  </template>
                   {{cardid}}
                </el-descriptions-item>
                </el-descriptions>
               
                <span class="txt4">测评信息</span>
                <el-descriptions class="margin-top" style="margin-top:15px" :column="1" border v-if="score">
                <el-descriptions-item>
                  <template slot="label">
                    测评专业
                  </template>
                   {{testpapertitle}}
                  </el-descriptions-item>
                  <el-descriptions-item>
                <template slot="label">
                    测评时间
                </template>
                  {{examtime}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                   <template slot="label">
                    卷面总分
                  </template>
                    {{totalscore}}
                  </el-descriptions-item>
                  <el-descriptions-item>
                  <template slot="label">
                    最终得分
                  </template>
                   {{score}}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    测评方式
                  </template>
                   线上测评
                </el-descriptions-item>
                </el-descriptions>
                <h4 v-else style="text-align: -webkit-center;margin-top: 10px;color:red;">未参加测评，如有疑问请联系系统管理员</h4>
                <div class="main11 flex-row justify-between">
                  <span class="txt6"><a v-if="score"  :href="`https://www.zhcpw.org.cn/achieveview/${recordid}`" style="color:rgb(30 91 185);font-weight:bold">查看试卷详情</a><a v-else :href="`https://www.zhcpw.org.cn`" style="color:rgb(30 91 185);font-weight:bold">去参加测评</a></span>
                  <div class="layer2 flex-col"></div>
                </div>
              </div>
            </div>
            
          <FooterNav/>
          </div>
        </div>
      </div>
    </div>
  </div>
    </div>
</template>

<script>
import global from "../components/PublicComs/Common.vue";
import HeadNav from "../components/PublicComs/Header.vue";
import FooterNav from "../components/HomeComs/FooterNav.vue";
const rate= window.innerWidth/1920;
export default {
   metaInfo: {
       meta: [
        { name:'viewport', content:
        `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
      ]
    },
  data () {
    return {
        bigQusts:[],
        paperInfo:{},
        global,
        name: "",
        cardid:"",
        testpapertitle:"",
        score: "",
        classhour: "",
        numid:"",
        sex:'',
        examtime:'',
        recordid:"",
        totalscore:""
    };
  },
  components: {HeadNav,FooterNav},

  computed:{},

  mounted(){
         let paperInfo = this.$route.query;
        this.cardid = paperInfo.cardid;

        this.$axios.get(`/api/users/findMeByCardId?cardid=${this.cardid}`).then(res => {
            if(res.data){
               let user= res.data.user;
               this.name = user.name;
               this.numid = user.identificationcard;
               this.sex = user.sex;
               this.classhour = user.studyhours;
               let examAchieveMent = res.data.examAchieveMent[0];
               this.score = examAchieveMent.score;
               this.testpapertitle= examAchieveMent.testpapertitle;
               let examRecord = res.data.examRecord;
               this.recordid = examRecord._id;
               this.examtime = examRecord.ctime;
               this.totalscore = res.data.testPaper.totalscore;
            }
        });
  },

  methods: {
    //阿拉伯数字转中文数字
    NoToChinese(num) {
        if (!/^\d*(\.\d*)?$/.test(num)) {
            alert("Number is wrong!");
            return "Number is wrong!";
        }
        var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九");
        var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
        var a = ("" + num).replace(/(^0*)/g, "").split("."),
            k = 0,
            re = "";
        for (var i = a[0].length - 1; i >= 0; i--) {
            switch (k) {
                case 0:
                    re = BB[7] + re;
                    break;
                case 4:
                    if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
                        re = BB[4] + re;
                    break;
                case 8:
                    re = BB[5] + re;
                    BB[7] = BB[5];
                    k = 0;
                    break;
            }
            if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
            if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
            k++;
        }
        if (a.length > 1) //加上小数部分(如果有小数部分) 
        {
            re += BB[6];
            for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
        }
        return re;
    },
    print(){
        this.$print(this.$refs.print)
    }
  }
}

</script>
<style scoped>
.page {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.main1 {
  width: 100%;
}

.bd1 {
  width: 100%;
}

.main2 {
  width: 100%;
  height: 15px;
 
}

.main3 {
  z-index: 4;
  height: 286px;
  overflow: hidden;
  margin-top: 3px;
    text-align: center;
  width: 100vw;
  height: 384px;
  margin: auto;
  position: relative;
}
 @media screen and (max-width: 640px) {
   .main3 {
   height: 187px;
   }
 }

.infoBox1 {
  width: 453px;
  height: 88px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 34px;
  font-family: MicrosoftYaHei-Bold;
  text-align: left;
  line-height: 59px;
  white-space: nowrap;
  font-weight: bold;
}

.info1 {
  width: 453px;
  height: 88px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 29px;
  font-family: MicrosoftYaHei;
  text-align: left;
  line-height: 59px;
  overflow: hidden;
  
  text-overflow: ellipsis;
}

.main5 {
  z-index: -1;
  position: absolute;
  left: 0;
  top: -0px;
  width: 100vw;
  height: 384px;
background: url(/static/images/yicti.png) no-repeat top;
    background-size: contain;
    margin: auto;
}

.main6 {
  background-color: rgb(207 227 239 /17%);
  padding-top: 29px;
  width: 100%;

}

.group1 {
  width: 100%;
    
}

.layer1 {
  background-color: rgba(255, 255, 255, 1);
  z-index: 8;
      height: 617px;
  margin: auto;
  padding-top: 26px;
  width: 1200px;
  position: relative;
    background: url(/static/images/ddf.png)
}

.box1 {
  width: 1144px;
  height: 472px;

}

.info2 {
  width: 85px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 20px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  display: block;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
}

.main7 {
  background-color: rgba(240, 240, 240, 1);
  height: 58px;
  margin-top: 28px;
  width: 1144px;
  padding: 21px 0 0 122px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
}

.outer1 {
  width: 904px;
  height: 17px;
}

.txt1 {
  width: 36px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  display: block;
}

.info3 {
  width: 37px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 253px;
  display: block;
}

.info4 {
  width: 77px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 232px;
  display: block;
}

.txt2 {
  width: 36px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 233px;
  display: block;
}

.main8 {
  width: 930px;
  height: 14px;
  margin: 24px 0 0 114px;
}

.info5 {
  width: 44px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
}

.word1 {
  width: 14px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin-left: 264px;
  display: block;
}

.txt3 {
  width: 175px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
  margin: 1px 0 0 199px;
}

.word2 {
  width: 57px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
  margin: 1px 0 0 177px;
}

.txt4 {
  width: 85px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 20px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
      margin-top: 30px;
  display: block;
   font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
}

.main9 {
  background-color: rgba(240, 240, 240, 1);
  height: 58px;
  margin-top: 26px;
  width: 1144px;
  padding: 21px 0 0 75px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
}

.mod1 {
  width: 1009px;
  height: 18px;
}

.info6 {
  width: 36px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  display: block;
}

.word3 {
  width: 77px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 131px;
  display: block;
}

.txt5 {
  width: 37px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 145px;
  display: block;
}

.word4 {
  width: 76px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 136px;
  display: block;
}

.word5 {
  width: 77px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 112px;
  display: block;
}

.word6 {
  width: 77px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 105px;
  display: block;
}

.main10 {
  width: 1006px;
  height: 14px;
  margin: 24px 0 0 56px;
}

.word7 {
  width: 75px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
}

.word8 {
  width: 147px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
  margin: 1px 0 0 78px;
}

.word9 {
  width: 27px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
  margin: 1px 0 0 114px;
}

.info7 {
  width: 18px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
  margin: 1px 0 0 164px;
}

.word10 {
  width: 59px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin-left: 155px;
  display: block;
}

.word11 {
  width: 33px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin-left: 136px;
  display: block;
}

.main11 {
  width: 130px;
  height: 19px;
  margin: 84px 0 0 1003px;
}

.txt6 {
  width: 103px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(101, 20, 171, 1);
  font-size: 16px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 1px;
  display: block;
}

.layer2 {
  width: 11px;
  height: 19px;
  background: url(/static/images/right.png) -1px -1px
    no-repeat;
}

.box2 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 21;
  position: absolute;
  left: 312px;
  top: 77px;
  width: 1px;
  height: 116px;
}

.box3 {
  z-index: 24;
  position: absolute;
  left: 28px;
  top: 74px;
  width: 1143px;
  height: 119px;
  border: 1px solid rgba(209, 209, 209, 1);
}

.box4 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 22;
  position: absolute;
  left: 607px;
  top: 77px;
  width: 1px;
  height: 116px;
}

.box5 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 23;
  position: absolute;
  left: 902px;
  top: 77px;
  width: 1px;
  height: 116px;
}

.box6 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 39;
  position: absolute;
  left: 209px;
  top: 302px;
  width: 1px;
  height: 116px;
}

.box7 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 40;
  position: absolute;
  left: 405px;
  top: 302px;
  width: 1px;
  height: 116px;
}

.box8 {
  z-index: 44;
  position: absolute;
  left: 28px;
  top: 299px;
  width: 1143px;
  height: 119px;
  border: 1px solid rgba(209, 209, 209, 1);
}

.box9 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 42;
  position: absolute;
  left: 602px;
  top: 302px;
  width: 1px;
  height: 116px;
}

.box10 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 41;
  position: absolute;
  left: 798px;
  top: 302px;
  width: 1px;
  height: 116px;
}

.box11 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 43;
  position: absolute;
  left: 994px;
  top: 302px;
  width: 1px;
  height: 116px;
}

.layer3 {
  background-color: rgba(49, 49, 49, 1);
  height: 38px;
  margin-top: 88px;
  width: 100%;
}
@media screen and (max-width: 640px) {
  .layer3 {
     margin-top: 58px;
  }
}
.word12 {
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(183, 183, 183, 1);
  font-size: 13px;
  font-family: PingFang-SC-Medium;
  text-align: center;
  white-space: nowrap;
  line-height: 13px;
  display: block;
  margin: auto;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}
body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
}
button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}
.box-card{
  width: 95%;
  margin:auto;
}
@media screen and (min-width: 640px) {
  .info1{
        font-size: 25px;
        line-height: 21px;
        height: 88px;
  }
  .infoBox1{
        font-size: 30px;
            line-height: 30px;
            white-space: break-spaces;
  }
  .main4{
    height:138px;
  }
  /deep/ .el-descriptions :not(.is-bordered) .el-descriptions-item__cell{
    width: 360px;
    font-size: 14px;
  }
  /deep/ .el-descriptions-item__label.is-bordered-label{
    text-align: right !important;
      width: 20% !important;
       color: #333;
    font-family: PingFang-SC-Bold;
    font-size: 18px !important;
    font-weight: 600 !important;
  }
  .margin-top{
    margin-top:20px;
  }
}

@media screen and (max-width: 640px) {
  .info1{
        font-size: 25px;
        line-height: 21px;
        height: 88px;
  }
  .infoBox1{
        font-size: 30px;
            line-height: 30px;
            white-space: break-spaces;
  }
  .main4{
    height:138px;
  }
  /deep/ .el-descriptions-item__label.is-bordered-label{
  text-align: right !important;
    width: 35%;
     
  }
}
.kscj{
  font-size: 24px;
  background-image:url(/static/images/biaoto.png);
  background-size:cover;
  width:279px;
  height:60px;
  line-height:60px;
  text-align:center;
}

</style>